import React from "react";
import Header from "../header/Header";
import Tabs from "../tabs/Tabs";
import Footer from "../footer/Footer";
import OrderDetailComponent from "../orderDetail/OrderDetail";

const Home: React.FC = () => {
  return (
    <>
      <Header />
      <Tabs />
      <Footer />
      <OrderDetailComponent />
    </>
  );
};

export default Home;
